/*eslint-disable*/
import React, { useEffect, useState, } from "react";
import db from "../../db"

// reactstrap components
import {
    Container
} from "reactstrap";

// core components
import ColorNavbar from "../../components/Navbars/ColorNavbar";
import EventCategories from "../../components/Admin/EventCategories/EventCategories"
import { LoadingScreen } from "../../components/MiscFunctions"

function AdminEventCategories() {
    document.documentElement.classList.remove("nav-open");

    const [categories, setCategories] = useState([])
    useEffect(() => db.EventCategories.listenAll(setCategories), [])

    return (
        <div style={{ minHeight: "100vh" }} className="section-dark">
            {
                !categories || categories && categories.length > 0 ?
                    <>
                        <ColorNavbar changing={false} />
                        <div className="section section-dark" id="edit" style={{ minHeight: "100vh" }}>
                            <div className="projects-3 " id="projects-3" style={{ paddingTop: 0, height: "auto" }}>
                                <Container style={{ minWidth: "100%" }}>
                                    <EventCategories size="4" categories={categories} />
                                </Container>
                            </div>
                        </div>
                    </>
                    :
                    <LoadingScreen />
            }
        </div>
    );
}

export default AdminEventCategories;
